import { useWatch } from 'react-hook-form';
import { Flooding } from 'features/flooding/flooding.types';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { GeoEventRegion } from 'features/geoEvents/geoEventRegion.types';
import {
  getGeoEventRegionsChanged,
  GeoEventRegionsChanged,
} from './useGeoEventRegionsChanged.utils';

type UseGeoEventRegionsChangedProps = {
  geoEvent?: Wildfire | Flooding;
  /** Baseline to diff against, overriding `geoEvent.regions`. */
  initialRegions?: GeoEventRegion[];
};

export const useGeoEventRegionsChanged = (
  props: UseGeoEventRegionsChangedProps,
): GeoEventRegionsChanged => {
  const { geoEvent, initialRegions } = props;

  const regions = useWatch<{ regions: GeoEventRegion[] }>({
    name: 'regions',
  }) as GeoEventRegion[] | null;

  return getGeoEventRegionsChanged(
    initialRegions ?? geoEvent?.regions ?? [],
    regions,
  );
};
